module.exports = __webpack_public_path__ + "static/media/list_color.d0e542ee.png";